import { render, staticRenderFns } from "./SyncInfoButton.vue?vue&type=template&id=216c3929&scoped=true"
import script from "./SyncInfoButton.vue?vue&type=script&lang=js"
export * from "./SyncInfoButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216c3929",
  null
  
)

export default component.exports